import { Lightning, Lightning as lng, Log } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';

const _Constants = {
  h: 100,
  padding: 8,
  LabelFontsize: 30,
};

// todo find better name for this?
export class Dropdown extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      rect: true,
      color: Theme.Colors.Transparent,
      h: _Constants.h,
      w: w => w,
      Background: {
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 10,
        },
        rect: true,
        x: 0,
        y: 0,
        w: w => w,
        h: _Constants.h,
        color: Theme.Colors.Option.Background.Item,
      },
      TitleLabel: {
        x: _Constants.padding * 2,
        y: _Constants.padding,

        text: {
          ...Theme.Fonts.Option.Item,
          fontSize: _Constants.LabelFontsize,
          lineHeight: _Constants.h / 2 - _Constants.padding * 2,
          color: Theme.Colors.Option.Text.Normal,
        },
      },
      SelectionLabel: {
        x: _Constants.padding * 2,
        y: _Constants.h / 2,

        text: {
          ...Theme.Fonts.Option.Item,
          lineHeight: _Constants.h / 2 - _Constants.padding,
          textColor: 0xb3ffffff,
        },
      },
    };
  }

  set title(val) {
    this._title = val;
    const titleTag = this.tag('TitleLabel');
    const textTexture = titleTag.text;
    textTexture.text = val;
  }

  set items(val) {
    this._items = val;
    this.selected = 0;
  }

  set selected(val) {
    // add error handling on invalid indexes
    if (val < 0 || val > this._items.length - 1) {
      this.selectedItem = 0;
    } else {
      this.selectedItem = val;
    }
    const selectionTag = this.tag('SelectionLabel');
    const selectionTextTexture = selectionTag.text;
    const items = this._items[this.selectedItem];
    const newText = items.text;
    selectionTextTexture.text = newText;
  }

  _handleEnter() {
    this.fireAncestors(
      '$openDialog',
      {
        type: SelectOptionDialog,
        params: {
          backend: this._backend,
          title: this._title,
          options: this._items,
          onSuccess: (val, idx) => {
            if (this.selectedItem !== idx) {
              this.signal('valueChanged', val, idx);
              this.selected = idx;
            }
            this.fireAncestors('$closeDialog');
          },
          onCancelled: () => {
            Log.info('cancelled');
            this.fireAncestors('$closeDialog');
          },
        },
      },
      true
    );
  }

  _focus() {
    this.tag('Background').setSmooth('color', Theme.Colors.Option.Background.Focus);
  }

  _unfocus() {
    this.tag('Background').setSmooth('color', Theme.Colors.Option.Background.Item);
  }
}
